module.exports = __webpack_public_path__ + "img/javitas_kep4.7828e41e.png";